import * as LabelPrimitive from '@radix-ui/react-label';

import { cn } from '../../lib/styles';

export function Label({ className, ...rest }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex items-center text-left gap-2 select-none',
        'font-heading-l font-semibold text-text-primary dark:text-white',
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...rest}
    />
  );
}
